import type { CustomerOriginQueryParamValue } from '@libs/feature-toggle';
import type { Serializer } from '@libs/utils';

export const CustomerOriginSerializer: Serializer<CustomerOriginQueryParamValue> =
  {
    serialize: (
      customerOrignQueryParam: CustomerOriginQueryParamValue
    ): CustomerOriginQueryParamValue => customerOrignQueryParam,
    deserialize: (
      customerOrignQueryParam: CustomerOriginQueryParamValue
    ): CustomerOriginQueryParamValue => customerOrignQueryParam,
  };
